import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { PartnerPaymentsState } from './store';

import { ApiPartnerPaymentsService } from './services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

@NgModule({
  imports: [
    NgxsModule.forFeature([ PartnerPaymentsState ])
  ],
  providers: [
    ApiPartnerPaymentsService,
    SnackbarService
  ],
})
export class PaymentsDataAccessModule {

  static forRoot(environment: Environment): ModuleWithProviders<PaymentsDataAccessModule> {
    return {
      ngModule: PaymentsDataAccessModule,
      providers: [{ provide: APP_ENVIRONMENT, useValue: environment }]
    };
  }

}
